import styled from '../../../theme/styled-with-theme';
import { mediaQueries } from '../../../styles/media-queries';

import { Box } from '../../Box';
import { GlImage } from '../../Image';

export const ImageWrapper = styled(Box)`
  width: 100%;
  position: relative;

  ${mediaQueries.tablet} {
    width: auto;
    flex: 1.5;
  }
`;

export const StyledImage = styled(GlImage, {
  shouldForwardProp: prop => prop !== 'rounded'
})<{ rounded?: boolean }>`
  max-width: 100%;
  display: block;
  margin: 0 auto;

  border-radius: ${({ theme, rounded }) =>
    rounded ? theme.borderRadius.block : 0};

  ${mediaQueries.desktop} {
    border-radius: ${({ theme, rounded }) =>
      rounded ? theme.borderRadius.block_desktop : 0};
  }
`;
